var UpliftUtil = {
  loadB2B: function(code) {
    if (!window.Uplift && code) {
      console.log("load uplift b2b");

      (function(u, p, l, i, f, t, o, b, j) {
        u["UpLiftPlatformObject"] = f;
        (u[f] =
          u[f] ||
          function() {
            (u[f].q = u[f].q || []).push(arguments);
          }),
          (u[f].l = 1 * new Date());
        (b = p.createElement(l)), (j = p.getElementsByTagName(l)[0]);
        b.async = 1;
        b.src = i + "?id=" + t;
        j.parentNode.insertBefore(b, j);
        o = u.location.host.match(/[\w-]+\.\w{2,3}(:\d+)?$/);
        if (o) {
          o = o[0];
        }
        u[f]("create", t, o);
      })(
        window,
        document,
        "script",
        "https://cdn.uplift-platform.com/a/up.js",
        "up",
        "UP-" + code
      );
    }
  },

  loadB2C: function(code) {
    if (!window.Uplift && code) {
      console.log("load uplift b2c");

      (function(u, p, l, i, f, t, o, b, j) {
        u["UpLiftPlatformObject"] = f;
        (u[f] =
          u[f] ||
          function() {
            (u[f].q = u[f].q || []).push(arguments);
          }),
          (u[f].l = 1 * new Date());
        (b = p.createElement(l)), (j = p.getElementsByTagName(l)[0]);
        b.async = 1;
        b.src = i + "?upcode=" + t;
        j.parentNode.insertBefore(b, j);
        o = u.location.host.match(/[\w-]+\.\w{2,3}(:\d+)?$/);
        if (o) {
          o = o[0];
        }
        u[f]("create", t, o);
      })(
        window,
        document,
        "script",
        "https://tag.uplift.com/external/up.js",
        "up",
        "UP-" + code
      );
    }
  },

  initB2B: function(settings, isCheckout) {
    console.log("util init b2b");

    var UpliftObj = window.Uplift.Agent;

    var options = settings.agentInfo;

    options.checkout = isCheckout || false;

    UpliftObj.init(options);

    return UpliftObj;
  },

  initB2C: function(settings, isCheckout) {
    console.log("util init b2c");

    var UpliftObj = window.Uplift;

    var options = {
      locale: settings.agentInfo.locale,
      currency: settings.agentInfo.currency
    };

    if (isCheckout) {
      options.checkout = true;
      options.container = settings.agentInfo.payMonthlyContainer;
      options.onChange = settings.agentInfo.onChange;
    }

    UpliftObj.Payments.init(options);

    return UpliftObj;
  },

  setTripId: function(id, tripId) {
    var upliftData =
      JSON.parse(window.sessionStorage.getItem("uplift-" + id)) || {};

    upliftData.tripId = tripId;

    window.sessionStorage.setItem("uplift-" + id, JSON.stringify(upliftData));
  },

  getTripId: function(id) {
    var upliftData =
      JSON.parse(window.sessionStorage.getItem("uplift-" + id)) || {};

    if (upliftData.tripId) {
      console.log("return id");

      return upliftData.tripId;
    }

    return null;
  },

  removeTripId: function(id) {
    console.log("remove tripid");

    var upliftData =
      JSON.parse(window.sessionStorage.getItem("uplift-" + id)) || {};

    upliftData.tripId = null;

    window.sessionStorage.setItem("uplift-" + id, JSON.stringify(upliftData));
  },

  setPaymentOptions: function(id, options) {
    console.log("set payment options");

    var upliftData =
      JSON.parse(window.sessionStorage.getItem("uplift-" + id)) || {};

    upliftData.paymentOptions = "";

    var optionList = [];

    for (var x = 0; x < options.length; x++) {
      optionList.push(UpliftUtil.getUpliftPaymentMethodString(options[x]));
    }

    upliftData.paymentOptions = optionList.toString();

    console.log(upliftData);

    window.sessionStorage.setItem("uplift-" + id, JSON.stringify(upliftData));
  },

  getPaymentOptions: function(id) {
    var upliftData =
      JSON.parse(window.sessionStorage.getItem("uplift-" + id)) || {};

    console.log("get payment options ");
    console.log("options: " + upliftData.paymentOptions || "");

    return upliftData.paymentOptions || "";
  },

  processSessionTokenCallback: function(data) {
    console.log("callback");
    console.log(data);

    return "asdf";
  },

  getUpliftPaymentMethodString: function(paymentOptionType) {
    console.log("get uplift payment method string");

    var method = "other";

    switch (paymentOptionType) {
      case "full_payment":
        method = "full";
        break;

      case "deposit":
        method = "deposit";
        break;

      case "no_payment":
        method = "hold";
        break;

      case "installment":
        method = "pay monthly";
        break;
    }

    console.log("method: " + method);

    return method;
  }
};

module.exports = UpliftUtil;
